export const removeAlphaFromHex = (hexColor: string) => {
  // Check for the '#' prefix and an 8-digit color code
  if (hexColor.startsWith('#') && hexColor.length === 9) {
    // Return the substring from the start up to the 7th character (skipping the last two)
    return hexColor.substring(0, 7) as string
  }
  // Return the original color if it's not a valid 8-digit hex format
  return hexColor as string
}
